import PropTypes from 'prop-types';
import StructuredContent from '@nerdwallet/structured-content';
import UniversalContainer from '../universal-container';
import { stringInputSpec, wrapper } from '../../lib/editing-configs';

const FIELD_NAME = 'bainReferralBanner';

function getProps(key, props) {
  if (props[key]) return props[key];
  return props;
}

function BainReferralBannerSC(props) {
  const {
    container,
    heading,
    subHeading,
    buttonCtaText,
    buttonSubText,
    offerId,
  } = getProps(FIELD_NAME, props);

  return (
    <UniversalContainer {...container} data-testid="BainReferralBannerSC">
      <StructuredContent>
        {{
          type: 'BainReferralBanner',
          version: '1.0.0',
          props: {
            heading,
            subHeading,
            buttonCtaText,
            buttonSubText,
            offerId,
          },
        }}
      </StructuredContent>
    </UniversalContainer>
  );
}

BainReferralBannerSC.getEditingConfig = (
  componentDocument,
  fieldName = FIELD_NAME
) => [
  wrapper([
    ...UniversalContainer.getEditingConfig(
      componentDocument,
      'Container',
      [
        'backgroundColor',
        'backgroundImage',
        'border',
        'margin',
        'padding',
        'hide',
        'jumpLinkId',
      ],
      `${fieldName}.container`
    ),
    stringInputSpec(`${fieldName}.heading`, 'Heading'),
    stringInputSpec(`${fieldName}.subHeading`, 'Sub heading'),
    stringInputSpec(`${fieldName}.buttonCtaText`, 'Button CTA text'),
    stringInputSpec(`${fieldName}.buttonSubText`, 'Button sub-text'),
    stringInputSpec(`${fieldName}.offerId`, 'Offer ID'),
  ]),
];

BainReferralBannerSC.displayName = 'Bain referral banner SC';
BainReferralBannerSC.propTypes = {
  bainReferralBanner: PropTypes.object,
  container: PropTypes.object,
  heading: PropTypes.string,
  subHeading: PropTypes.string,
  buttonCtaText: PropTypes.string,
  buttonSubText: PropTypes.string,
  offerId: PropTypes.string,
};

export default BainReferralBannerSC;
